export default {
  workOrder: {
    WorkOrderWrite: 'Work Order Write',
    ServiceTime: 'Service Time',
    ServiceTutor: 'Service Tutor',
    CommunicationContent: 'Communication Content',
    UndoneBusiness: 'Undone Business',
    Coupon: 'Coupon',
    HasBeenSent: 'Has Been Sent',
    NotSentYet: 'Not Sent Yet',
    MemberLabel: 'Member Label',
    JointSales: 'Joint Sales',
    RepurchaseTime: 'Repurchase Time',
    ReasonOfLoss: 'Reason Of Loss',
    ChangeToBreastfeeding: 'Change To Breastfeeding',
    PhysicalReasons: 'Physical Reasons',
    ChangeToAnotherBrand: 'Change To Another Brand',
    DrinkMilkUntilDinner: 'Drink Milk Until Dinner',
    ResidenceMigration: 'Residence Migration',
    AsGift: 'As Gift',
    Other: 'Other'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/en/myg/serviceWorkOrder.js